module.exports = "thumb_like"